import { Injectable, inject } from '@angular/core';
import { ApplicationInsights } from '@microsoft/applicationinsights-web';
import { EnvService } from 'app/core/services';

@Injectable({
  providedIn: 'root',
})
export class ApplicationInsightService {
  readonly appInsights: ApplicationInsights;
  constructor() {
    const envService = inject(EnvService);
    this.appInsights = new ApplicationInsights({
      config: {
        instrumentationKey: envService.appInsightInstrumentationKey,
        enableAutoRouteTracking: true, // option to log all route changes
      },
    });
    if (envService.allowAppInsightLog) {
      this.appInsights.loadAppInsights();
    }
  }

  logException(exception: Error, severityLevel?: number) {
    this.appInsights.trackException({
      exception: exception,
      severityLevel: severityLevel,
    });
  }
}
